import { render, staticRenderFns } from "./MsgInputDialog.vue?vue&type=template&id=278bafce"
import script from "./MsgInputDialog.vue?vue&type=script&lang=js"
export * from "./MsgInputDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports